import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { siteInfo, faqs } from '@/mocks/comics';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '体育西路123号',
      addressLocality: '广州市',
      addressRegion: '广东省',
      addressCountry: 'CN',
      postalCode: '510620',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      telephone: siteInfo.phone,
      email: siteInfo.email,
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify([organizationSchema, faqSchema]) }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="py-8 md:py-12">
            <div className="text-center mb-12">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                关于女神漫画
              </h1>
              <p className="text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                女神漫画网官网致力于为漫画爱好者提供海量免费韩漫、日漫、国漫全集阅读服务，
                打造一站式在线阅读平台
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
              <div className="rounded-xl p-8 bg-background-100 text-center">
                <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-book-read-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                  海量资源
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  涵盖韩漫、日漫、国漫等各类漫画资源，
                  收录热门连载与经典完结作品，
                  每日更新最新章节
                </p>
              </div>

              <div className="rounded-xl p-8 bg-background-100 text-center">
                <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                  完全免费
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  所有漫画内容均完全免费开放阅读，
                  无需注册登录即可畅读，
                  致力于降低漫画阅读门槛
                </p>
              </div>

              <div className="rounded-xl p-8 bg-background-100 text-center">
                <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-smartphone-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">
                  极致体验
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  支持下拉式在线阅读模式，
                  适配电脑、平板、手机等多终端，
                  提供流畅舒适的阅读体验
                </p>
              </div>
            </div>
          </section>

          <section className="py-8 md:py-12 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-[900px] mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  品牌口碑
                </h2>
                <p className="text-sm text-foreground-500">来自漫画爱好者的真实评价</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="rounded-xl p-6 bg-background-50">
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "女神漫画的更新速度真的很快，而且画质清晰，阅读体验特别好。韩漫资源最全，是我每天必刷的漫画平台！"
                  </p>
                  <p className="text-xs text-foreground-400 font-medium">—— 漫画迷小林</p>
                </div>

                <div className="rounded-xl p-6 bg-background-50">
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "下拉式阅读太方便了，不用一页页翻，一口气能看好多话。分类也很清楚，找漫画特别快。强烈推荐！"
                  </p>
                  <p className="text-xs text-foreground-400 font-medium">—— 二次元爱好者阿星</p>
                </div>

                <div className="rounded-xl p-6 bg-background-50">
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    "国漫资源越来越丰富了，斗破苍穹、一人之下都在追。女神漫画的排行榜也很靠谱，帮我发现了不少好漫画。"
                  </p>
                  <p className="text-xs text-foreground-400 font-medium">—— 国漫忠实粉丝大刘</p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-8 md:py-12">
            <div className="max-w-[900px] mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  常见问题
                </h2>
                <p className="text-sm text-foreground-500">关于女神漫画的常见疑问解答</p>
              </div>

              <div className="space-y-3">
                {faqs.map((faq, index) => (
                  <details key={index} className="group rounded-xl bg-background-100 overflow-hidden">
                    <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                      <span className="text-sm font-medium text-foreground-900 pr-4">
                        {faq.question}
                      </span>
                      <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          <section className="py-8 md:py-12 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-[900px] mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-500">如有任何问题或建议，欢迎通过以下方式联系我们</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex items-start gap-4 p-4 rounded-xl bg-background-50">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-500">{siteInfo.email}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 rounded-xl bg-background-50">
                    <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-accent-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-900 mb-1">客服电话</h4>
                      <p className="text-sm text-foreground-500">{siteInfo.phone}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 rounded-xl bg-background-50">
                    <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-secondary-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-900 mb-1">公司地址</h4>
                      <p className="text-sm text-foreground-500">{siteInfo.address}</p>
                    </div>
                  </div>
                </div>

                <div className="rounded-xl bg-background-50 p-6">
                  <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">
                    给我们留言
                  </h3>
                  {formStatus === 'success' ? (
                    <div className="text-center py-8">
                      <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                        <i className="ri-check-line text-2xl text-accent-600"></i>
                      </div>
                      <p className="text-sm font-medium text-foreground-900">留言已成功提交！</p>
                      <p className="text-xs text-foreground-500 mt-1">我们会尽快回复您</p>
                      <button
                        onClick={() => setFormStatus('idle')}
                        className="mt-4 text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
                      >
                        发送新留言
                      </button>
                    </div>
                  ) : (
                    <form
                      data-readdy-form
                      className="space-y-4"
                      onSubmit={async (e) => {
                        e.preventDefault();
                        const form = e.currentTarget;
                        const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                        if (honeypot) {
                          setFormStatus('success');
                          form.reset();
                          return;
                        }
                        try {
                          const formData = new FormData(form);
                          formData.delete('website_alt');
                          const response = await fetch('https://readdy.ai/api/form/d9on5raqs38sj6jc7bt0', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                          });
                          const responseText = await response.text();
                          let parsed;
                          try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                          if (response.ok && parsed?.code === 'OK') {
                            setFormStatus('success');
                            setFormError('');
                            form.reset();
                          } else {
                            const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
                            setFormError(serverMsg || '提交失败，请稍后再试');
                            setFormStatus('error');
                          }
                        } catch {
                          setFormError('网络错误，请稍后再试');
                          setFormStatus('error');
                        }
                      }}
                    >
                      {formStatus === 'error' && formError && (
                        <div className="p-3 rounded-lg bg-accent-100 text-accent-700 text-xs">{formError}</div>
                      )}
                      <div>
                        <input
                          type="text"
                          name="name"
                          placeholder="您的称呼"
                          required
                          className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors"
                        />
                      </div>
                      <div>
                        <input
                          type="email"
                          name="email"
                          placeholder="您的邮箱"
                          required
                          className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors"
                        />
                      </div>
                      <div>
                        <textarea
                          name="message"
                          placeholder="请输入您的留言内容..."
                          maxLength={500}
                          rows={4}
                          required
                          className="w-full px-4 py-3 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-colors resize-none"
                        ></textarea>
                        <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
                      </div>
                      <input
                        type="text"
                        name="website_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                        className="honeypot-field"
                      />
                      <button
                        type="submit"
                        className="w-full py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        提交留言
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}